const lintMessages = {
  "no-console": "O uso de console.log não é recomendado em produção, pois pode expor informações sensíveis ou desnecessárias no log.",
  "eqeqeq": "Utilize '===' no lugar de '==' para evitar problemas com comparação de tipos em JavaScript.",
  "no-unused-vars": "Existem variáveis declaradas que não estão sendo utilizadas no código.",
  "semi": "Adicione ponto e vírgula ao final de cada instrução para evitar problemas de interpretação.",
  "indent": "Ajuste a indentação do código para manter uma estrutura organizada e legível.",
  "no-var": "Evite usar 'var'; prefira 'let' ou 'const' para declarar variáveis.",
  "prefer-const": "Use 'const' sempre que possível para evitar reatribuições acidentais.",
  "arrow-spacing": "Certifique-se de adicionar espaços antes e depois de '=>' em funções arrow.",
  "no-debugger": "O uso de 'debugger' não é permitido em produção.",
  "no-undef": "Certifique-se de que todas as variáveis estejam declaradas antes do uso.",
  "camelcase": "Use nomes de variáveis e funções no formato camelCase para consistência.",
  "parsing-error": "Erro de parsing: Certifique-se de que o código está bem formatado e correto.",
};

export default lintMessages;
